export default "__VITE_ASSET__9af4bab4__"